<template>
  <svg viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 6.26795C13.3333 7.03775 13.3333 8.96225 12 9.73205L3 14.9282C1.66667 15.698 -7.31543e-07 14.7358 -6.64245e-07 13.1962L-2.09983e-07 2.80385C-1.42685e-07 1.26425 1.66667 0.301995 3 1.0718L12 6.26795Z"
      fill="url(#paint0_linear_4490_242914)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4490_242914"
        x1="15"
        y1="-2"
        x2="14.53"
        y2="18.4489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A493D8" />
        <stop offset="1" stop-color="currentColor" />
      </linearGradient>
    </defs>
  </svg>
</template>
